import React from 'react';

import _ from 'lodash';

import './ValidationProductTableRow.scss';

class ValidationProductTableRow extends React.Component {
  render() {
    const {
      data,
      editMode,
      onDelete
    } = this.props;

    return (
      <div className="parkchirp--validation-product-table-row">
        <div className="parkchirp--validation-product-table--cell">
          {data.productName}
          {editMode &&
            <button
              type="button"
              className="parkchirp--button-as-link delete-product-button"
              onClick={onDelete}>
              Delete
            </button>
          }
        </div>
      </div>
    )
  }
}

export default ValidationProductTableRow;